// ABOUTME: Withdraw dialog hook using global dialog store
// ABOUTME: Manages withdraw dialog state with available balance data

import { useGlobalDialogs } from "@/shared/model/global-dialogs";

const DIALOG_ID = "withdraw";

type WithdrawDialogData = {
  availableBalance: number;
};

export function useWithdrawDialog() {
  const {
    isOpen,
    open: openDialog,
    close,
    data,
  } = useGlobalDialogs<WithdrawDialogData>();

  return {
    isOpen: isOpen(DIALOG_ID),
    setIsOpen: (open: boolean) => (open ? openDialog(DIALOG_ID) : close()),
    open: (balance: number) =>
      openDialog(DIALOG_ID, { availableBalance: balance }),
    close,
    availableBalance: data?.availableBalance ?? 0,
  };
}
